/** Available deadline types */
export enum DeadlineTypeEnum {
  /** Relative deadline - N days after the use date of the entity with the deadline */
  RELATIVE = 'RELATIVE',
  /** Absolute deadline - concrete day of the current or of the next month */
  ABSOLUTE = 'ABSOLUTE',
}
